import { Controller } from "@hotwired/stimulus";

// Copies a string to the clipboard and shows brief "Copied!" feedback.
// Use data-clipboard-text-value for the string, or data-clipboard-source-value
// as a CSS selector for an input/textarea to copy from.
export default class extends Controller {
  static values = {
    text: String,
    source: String,
  };

  copy(event) {
    event.preventDefault();
    const text = this.resolveText();
    if (!text) return;

    navigator.clipboard
      .writeText(text)
      .then(() => {
        this.showSuccess();
      })
      .catch(() => {
        this.showError();
      });
  }

  resolveText() {
    if (this.hasTextValue) return this.textValue;
    if (this.hasSourceValue) {
      const el = document.querySelector(this.sourceValue);
      return el?.value ?? el?.textContent?.trim() ?? null;
    }
    return null;
  }

  showSuccess() {
    const label =
      this.element.querySelector("[data-clipboard-label]") || this.element;
    const original = label.textContent;
    label.textContent = "Copied!";
    label.setAttribute("aria-label", "Copied to clipboard");
    setTimeout(() => {
      label.textContent = original;
      label.removeAttribute("aria-label");
    }, 2000);
  }

  showError() {
    const label =
      this.element.querySelector("[data-clipboard-label]") || this.element;
    const original = label.textContent;
    label.textContent = "Copy failed";
    setTimeout(() => {
      label.textContent = original;
    }, 2000);
  }
}
